// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminBusinessSearchResponse

import { hydrateBusinessAdmin, type BusinessAdmin, type BusinessAdminApiResponse } from './businessAdmin.gen';

export type AdminBusinessSearchApiResponse = {
	items: BusinessAdminApiResponse[];
};

export type AdminBusinessSearch = {
	items: BusinessAdmin[];
};

export function hydrateAdminBusinessSearch(data: AdminBusinessSearchApiResponse): AdminBusinessSearch {
	return {
		...data,
		items: data.items.map(hydrateBusinessAdmin),
	};
}